import React__default from 'react';
import { useHeaderContext } from '../../context.js';
import { MobileView } from './mobile-view/index.js';
import { PCView } from './pc-view/index.js';

var UserCenter = function UserCenter() {
  var _useHeaderContext = useHeaderContext(),
      isMobileView = _useHeaderContext.isMobileView;

  return isMobileView ? /*#__PURE__*/React__default.createElement(MobileView, null) : /*#__PURE__*/React__default.createElement(PCView, null);
};

export { UserCenter };
